<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="title">Article View</span>
        <v-spacer></v-spacer>
        <v-icon @click="closeView">close</v-icon>
      </v-card-title>
      <v-card-text v-if="clip">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs4>
              <span class="font-weight-bold">Translated Headline</span>
            </v-flex>
            <v-flex xs8>
              <span>{{ clip.headline }}</span>
            </v-flex>
            <v-flex xs4>
              <span class="font-weight-bold">Publication</span>
            </v-flex>
            <v-flex xs8>
              <span>{{ clip.media.name }}</span>
            </v-flex>
            <v-flex xs4>
              <span class="font-weight-bold">Date</span>
            </v-flex>
            <v-flex xs8>
              <span>{{ clip.journal.publishDate | parseFormat2 }}</span>
            </v-flex>
            <v-flex xs4>
              <span class="font-weight-bold">Tone</span>
            </v-flex>
            <v-flex xs8>
              <span>{{ clip.tone }}</span>
            </v-flex>
            <v-flex xs4>
              <span class="font-weight-bold">PR Value</span>
            </v-flex>
            <v-flex xs8>
              <span>{{ clip.prValue | txtInAmt }}</span>
            </v-flex>
            <v-flex xs4>
              <span class="font-weight-bold">Author</span>
            </v-flex>
            <v-flex xs8>
              <span>{{ clip.author }}</span>
            </v-flex>
            <v-flex xs4>
              <span class="font-weight-bold">Summary</span>
            </v-flex>
            <v-flex xs8>
              <span>{{ clip.summary }}</span>
            </v-flex>
            <v-flex xs12>
              <br>
              <v-img :src="clip.screenshot" :max-height="500" contain />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import custom_date from "@/mixins/custom_date";
import custom_text from "@/mixins/custom_text";

export default {
  name: "ClipArticleView",

  mixins: [ custom_date, custom_text ],

  props: [
    "clip"
  ],

  methods: {
    closeView() {
      this.$emit("closeview");
    }
  },
}
</script>

<style scoped>

</style>